import React, { useState } from 'react'
import './AddContactLabelModal.scoped.sass'

import { Button } from '@/components/Button/Button'
import { InputMask } from '@/components'
import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'

import modalService from '@/services/modal.service'
import contactslabelsService from '@/app-domains/contactslabels/contactslabels.service'

const AddContactLabelModal = (props) => {
  const { type, label } = props
  const [newLabelName, setNewLabelName] = useState()
  return (
    <div className='main-container'>
      <div className='top-header'>
        <div className='top-header-message'>
          {type === 'add' ? 'Add a contact label' : 'Edit contact label'}
        </div>
        <div className='close-icon' onClick={() => modalService.close()}>
          <CloseIcon />
        </div>
      </div>
      <div className='input'>
        <InputMask placeholder={type === 'edit' ? label.name : 'New label...'} onInput={(value) => {
          setNewLabelName(value)
        }}/>
      </div>
      <div className='buttons-group'>
        <div className='cancel-button'>
          <Button content='Cancel' type='secondary' click={() => {
            modalService.close()
          }}/>
        </div>
        <div className='add-button'>
          <Button content={type === 'edit' ? 'Edit label' : 'Add label'} click={async () => {
            if (type === 'edit') {
              await contactslabelsService.editContactLabel(label, { name: newLabelName })
            } else {
              contactslabelsService.addContactLabel(newLabelName)
            }
            modalService.close()
          }}/>
        </div>
      </div>
    </div>
  )
}

export default AddContactLabelModal
